import type { ProductListItem } from 'product-list/types/ProductsList'

export enum RenderingType {
	Server = 'server',
	Client = 'client',
}

export type InspirationalProductCardProps = {
	product: ProductListItem
	isTwoColumnSize?: boolean
	index?: number
}
